webpackJsonp([263791100135453],{

/***/ 23:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var SERVICES = exports.SERVICES = [{
	  name: "Artificial Intelligence",
	  desc: "Delving on the potential of AI and its practical use in our day-to-day operations.",
	  icon: "ai-icon"
	}, {
	  name: "Big Data",
	  desc: "Cooperating and managing cloud-based services with scalable data storage and analytics.",
	  icon: "big-data-icon"
	}, {
	  name: "Real-Time Bidding",
	  desc: "Working closely with RTB hosts who track, measure, analyze and gather real-time results.",
	  icon: "rtb-icon"
	}, {
	  name: "Computer Reservation System",
	  desc: "CRS platforms storing and retrieving info related to travel, vehicle rentals, and the like.",
	  icon: "reservation-icon"
	}, {
	  name: "SFM",
	  desc: "Protect your customers and reduce losses from fraud payments.",
	  icon: "sfm-icon"
	}, {
	  name: "Game Development",
	  desc: "Creating gaming environments that transcend real life experiences, while providing users with new dimensions of fun.",
	  icon: "game-dev-icon"
	}, {
	  name: "Affiliate Marketing",
	  desc: "Performance-based ad networks that award affiliates for bringing visitors to different sites, and vice versa.",
	  icon: "marketing-icon"
	}, {
	  name: "Software Development",
	  desc: "Engineering various projects such as software and applications that bring value to users.",
	  icon: "software-icon"
	}];
	
	var PROJECTS = exports.PROJECTS = [{
	  name: "Adwe.com",
	  title: "RTB Platform",
	  desc: "Managing a self-coded Real-Time-Bidding Platform which operates with all ad formats for both mobile and desktop users, handling over 5B daily requests globally. Minute after minute, inventory is being bought and sold through auctions, thus allowing both parties (advertisers and publishers) to seamlessly generate revenue.",
	  path: "adwe",
	  url: "/project/adwe",
	  realURL: "https://adwe.com"
	}, {
	  name: "Abago.com",
	  title: "Flight Search - OTA",
	  desc: "Harboring one of the biggest databases of flights all over the world to help people find, compare, and book economical air fares. The systems we integrate take care of rapid search conduct that automatically serves users with the right and most prominent option for their wished travel dates.",
	  path: "abago",
	  url: "/project/abago",
	  realURL: "https://abago.com"
	  /*
	  {
	    title: "Mobile Development",
	    desc: "Utilizing our in-house 3D engine for Android and iOS platforms which allows developers to easily create 2D and 3D mobile applications in native Android and iOS platforms. Through continuous upgrades and updates, we make sure that only educational and informational apps are being created for our users.",
	    path: "mobile-device",
	  }
	  */
	}];
	
	var MANAGMENT = exports.MANAGMENT = [];
	
	var ADMINISTRATION = exports.ADMINISTRATION = [];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _data = __webpack_require__(23);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _heroSmall = __webpack_require__(43);
	
	var _heroSmall2 = _interopRequireDefault(_heroSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_heroSmall2.default, {
	      title: "Entrepreneurs Evolving into Business People",
	      desc: "Get to know us better"
	    }),
	    _react2.default.createElement(
	      _container2.default,
	      { customClassName: "page-container" },
	      _react2.default.createElement(
	        "div",
	        { className: "page-sixth" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "The international economy scene coexists with businesses in a more and more complex, interconnected, and faster moving environment. Such events have to be veraciously followed by economists, business leaders, and policymakers through analytic tools in order to cater a broad and far-reaching perspective. To avoid loss of hidden potentials, unbalanced growth, and de trop market failures - we have committed ourselves to ventures of all kind that want to change the world for the better."
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Our Pledge to Founders"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Wisdom in managerial operations"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "To listen first, talk second"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Expeditious responsiveness"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Rationality in decision-making situations"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Allegiance in business"
	          )
	        ),
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "The beginning of time"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "With roots dating back to 2004, and a single office in Montenegro, now it\u2019s spread to eleven different pins on the global map. With assets ranging from a few hundred thousand to multi-million dollars, Webb Holding can call itself THE place to go to for investments and tech-related business consulting."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We identify markets and build technologies and online services used by millions of people around the world each day."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "Everything we do must be in the best interest of all parties involved"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Through our offices, we employ over 100 people that are mostly engaged in R&D related activities. We maintain an open, dynamic culture that allows us to bring quality products to different markets quickly and efficiently."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The idea is to encourage our people and foster an open mind while constantly thinking outside the box. It is for this very freedom of creativity that we are committed to a healthy balance between work and personal lives, enabling our people to meet their work commitments while juggling with personal responsibilities as well."
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Our Approach"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Our investment philosophy is to deliver immense profits for companies."
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "We Discover"
	            ),
	            " great innovation in tech."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "We Guard"
	            ),
	            " brands and their identity."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "We Shape"
	            ),
	            " business models for better opportunities."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "We Enhance"
	            ),
	            " companies in various enviroments."
	          )
	        ),
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement(
	          "h4",
	          { id: "testimonials" },
	          "Not just our portfolio - but our partners"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "Adwe testimonial"
	          ),
	          ":"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "testimonial" },
	          _react2.default.createElement(
	            "i",
	            null,
	            "\u201CDefinitely more of a partner than an investor.\u201D"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "Abago Testimonial"
	          ),
	          ":"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "testimonial" },
	          _react2.default.createElement(
	            "i",
	            null,
	            "\u201COur company deals with flights, but none of our fares reach as far as Webb Holding.\u201D"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "h4",
	          { id: "coorporate-responsibility" },
	          "Corporate Social Responsibility"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Webb Holding is proponent of social and environmental responsibility. We nurture ethical values, fairness in conducting business while protecting the environment."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Reducing carbon footprints is one important focus as a social responsibility for us and we do our best to lower-carbon economy. By operating effectively and advancing clean technology we are working on upgrading and improving environmental solutions and our ways of contribution as for that part."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We are committed to enhancing education as a relevant part of our employees as well as society in general. We empower our employees and other individuals or small businesses with services, products and knowledge in order to improve their professional lives as well as their quality of life."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "By treating our employees fairly and ethically we are advocates of long term growth and success. Diversity and social inclusion are part of our commitment and we ensure to respect and value all people involved in our business, communities and we tend to include all individuals regardless (following but not limited to) race, gender, sexual orientation, gender, ethnic origin, beliefs, culture, age, physical and mental abilities, life status, work status or employment level."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Supporting worthy causes by donations in the form of money, products or services are also one part of our corporate responsibility aspects."
	        ),
	        _react2.default.createElement(
	          "h4",
	          { id: "team" },
	          "Team"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Our team is consisted of people who enrich our existence by bringing a wealth of experience and we are led by those who constantly grow and create challenges on a daily basis."
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-d73adf91c211a45d2e8f.js